type PathParams<Path extends string> = Path extends `:${infer Param}/${infer Rest}`
  ? Param | PathParams<Rest>
  : Path extends `:${infer Param}`
    ? Param
    : // eslint-disable-next-line @typescript-eslint/no-unused-vars
      Path extends `${infer _Prefix}:${infer Rest}`
      ? PathParams<`:${Rest}`>
      : never

const interpolateParams = (path: string, params: Record<string, string>): string =>
  Object.entries(params).reduce((url, [key, value]) => url.replace(`:${key}`, value), path)

export const BASE_PATH = '/org'

const defineRoute = <T extends string>(path: T) => {
  return {
    path,
    route(params: Record<PathParams<T>, string>, customOrigin: string) {
      const relativePath = interpolateParams(path, params)
      return new URL(`${BASE_PATH}${relativePath}`, customOrigin)
    },
  }
}

export const ROUTES = {
  ACTIVITY_DETAILS: defineRoute('/activity/:activityId'),
  ACTIVITY_DETAILS_SPOTS: defineRoute('/activity/:activityId/spots'),
  ACTIVITY_DETAILS_AVAILABILITY: defineRoute('/activity/:activityId/availability'),
  PRODUCT_DETAILS: defineRoute('/product/:productId'),
  WIDGET: defineRoute('/widget/:widgetId'),
  OVERVIEW: defineRoute('/widget/overview'),
  VIDEO_DETAILS: defineRoute('/videos/:recordingId'),
} as const
